module.exports = __webpack_public_path__ + "img/default_car.7f5482c8.png";